<template>
    
    <div>
        <div class="notification is-warning" v-if="loading == true">
            Loading your data ...
        </div>

        <div class="columns">
          <div class="column is-one-third">
            <h3 class="title">Order Sizes</h3>

            <span v-for="row in sizesWithQtys" :key="row.id" :class="[{ 'has-text-danger': row.assigned > row.originalQty}, {'has-text-success': row.assigned == row.originalQty}, {'has-text-warning': row.assigned < row.originalQty}] ">{{ row.name }} : {{ row.assigned }}/{{ row.originalQty }}<br /></span>
            <br />
            <div style="display:none">
              <button  v-if="order.bundles_created==1" class="button is-success" @click="showPDF(order.orderID, order.ponumber)">Print Barcodes PDF</button>
              <br /><br />
            </div>
           
            <button  v-if="order.bundles_created==1" class="button is-success" @click="showPDFTest(order.orderID, order.ponumber)">Print Barcodes PDF</button>
           <div style="display:none">
<br style="clear:both" /><span> X offset (left margin) : <input v-model="x"  /></span><br />
            <span> Y offset (top margin) : <input v-model="y"  /></span><br />
           </div>
            
          </div>

         <div class="column" v-if="loading == false">
            <button class="button is-warning is-pulled-right" @click="generateSetBundles()" v-if="order.bundles_created==0 && this.bundle_sets == 0">Redo Bundles for Sets</button>
            <button class="button is-link is-pulled-right" @click="generateSizeBundles()" v-if="order.bundles_created==0 && this.bundle_sets == 1">Redo Bundles for Sizes</button>
                <h3 class="title">{{ order.bundles.length}} Bundles for {{ order.ponumber }} </h3>
                <div class="columns is-multiline">
                  <div class="column  is-half" v-for="(row, index) in order.bundles" :key="row.id">
                    <div class="box" :class="{'has-background-grey-light' : row.qty <= 0}">
                      <strong>Bundle {{ index+1 }}</strong><br />
                      <span > {{ row.name }} : <input type="number" v-model="row.qty" :disabled="order.bundles_created == 1"></span>
                    </div>
                  </div>
                </div>

                <button class="button is-success" @click="saveBundles()" :disabled="working==true" v-if="order.bundles_created == 0 && sizes_correct == true">Save Bundle Setup</button>
            </div>
        </div>
       
          
        
        
    </div>
</template>

<script>
import OrderService from '@/services/OrderService.js';
//import UtilityService from '@/services/UtilityService.js';
import axios from "axios"

import OrderMixin from "@/mixins/OrderMixin.js";

export default {
 name: 'Bundling',
  mixins: [OrderMixin],
  data() {
    
    return {
      order: {orderID: 0},
      area: '',
      loading: true,
      ponumber: '',
      access_token: '',
      sizes: [],
      machines: [],
      machine_id: '',
      order_id : this.$route.params.id,
      working: false,
      bundle_sets: 0,
      API_NAME: process.env.VUE_APP_API_NAME,
      x: 4,
      y:6
      
    }
  },
   methods: {
      async getOrder() {
        this.loading=true
        OrderService.getSingleOrder(this.accessToken, this.order_id, this.bundle_sets)
        .then(
          (order => {
            this.$set(this, "order", order);
           
            this.loading=false
            this.working = false
          }).bind(this)
        );
      },
      async getSizes() {
        OrderService.getSizes(this.accessToken)
        .then(
            (sizes => {
              
              this.$set(this, "sizes", sizes);
              
            }).bind(this)
          );
      },
      async saveBundles() {
        this.working = true

        var order_id = this.order.orderID

        var formdata = { 
            order_id: order_id,
            bundles : this.order.bundles
        }; 

        OrderService.saveBundles(this.accessToken, formdata)
        .then((updatedOrder) => {
             
            //console.log(response)

            this.order = updatedOrder
            this.working = false

            alert("Bundles saved")
        }).catch((error) => {
           if(error.response.status == 409)
           {
             alert("The bundles for this order have already been created. Please refresh the page or contact support.")
           }
           else{
            alert("Something went wrong and the order has not been updated. Please reload and try again")
            
           }
           console.log("Error:" + JSON.stringify(error.response.data));
           
            this.working = false
        });
        
      },
      async generateSetBundles()
      {
        this.bundle_sets = 1
        this.getOrder()
      },
      async generateSizeBundles()
      {
        this.bundle_sets = 0
        this.getOrder()
      },
      showPDF(order_id, ponumber) {
          var uri = this.API_NAME + "/orders/" + order_id + "?pdf=1"

          const pdfWindow = window.open('', '_blank')

          if (pdfWindow) {
            pdfWindow.document.write('<p style="font-family:sans-serif;padding:16px">Preparing PDF, this can take a few moments...</p>')
            pdfWindow.document.close()
          }

          axios({
              url: uri,
              method: 'GET',
              responseType: 'blob', // important
              headers: {
              Authorization: `Bearer ${this.accessToken}`
              }
  
          }).then(function (response) {
                  const url = window.URL.createObjectURL(new Blob([response.data], {type: 'application/pdf'}));
                  /*const link = document.createElement('a');
                  link.href = url;
                  
                  //link.innerText = "Click here";
                  //link.setAttribute('download', ponumber + '_barcodes.pdf');
                  link.setAttribute('target', '_blank');
                  
                  document.body.appendChild(link);
                  link.click();*/

                    if (pdfWindow) {
                      pdfWindow.location.href = url
                    } else {
                      window.open(url)
                    }
                  console.log(ponumber)
                  window.URL.revokeObjectURL(url);

          })
          .catch(function (error) {
              console.log(error)
          });
      },
      showPDFTest(order_id, ponumber) {
          var uri = this.API_NAME + "/orders/" + order_id + "/testpdf?x=" + this.x + "&y=" + this.y

          const pdfWindow = window.open('', '_blank')

          if (pdfWindow) {
            pdfWindow.document.write('<p style="font-family:sans-serif;padding:16px">Preparing PDF, this can take a few moments...</p>')
            pdfWindow.document.close()
          }

          axios({
              url: uri,
              method: 'GET',
              responseType: 'blob', // important
              headers: {
              Authorization: `Bearer ${this.accessToken}`
              }
  
          }).then(function (response) {
                  const url = window.URL.createObjectURL(new Blob([response.data], {type: 'application/pdf'}));
                  /*const link = document.createElement('a');
                  link.href = url;
                  
                  //link.innerText = "Click here";
                  //link.setAttribute('download', ponumber + '_barcodes.pdf');
                  link.setAttribute('target', '_blank');
                  
                  document.body.appendChild(link);
                  link.click();*/

                    if (pdfWindow) {
                      pdfWindow.location.href = url
                    } else {
                      window.open(url)
                    }
                  console.log(ponumber)
                  //window.URL.revokeObjectURL(url);

          })
          .catch(function (error) {
              console.log(error)
          });
      }
      
   },
   mounted() {
   
  },
  computed : {
      sizesWithQtys: function () {  
          let order = this.order
          let sizesWithQtys =  this.sizes.filter(function(u) {
            if( order[u.database_name] + order[u.database_name + '_GK'] > 0) 
            {
               console.log(u)
              return 1
            }
          })

          

          sizesWithQtys.forEach(element => {
              element.originalQty = this.order[element.database_name] + this.order[element.database_name + '_GK'];
              let assignedQty = 0

              // Loop through all bundle sizes
              this.order.bundles.forEach(bundle => {
                let sum = 0
                /*let sum = bundle.reduce(function (previousValue, currentValue) {
                    if(currentValue.size_id == element.id)
                    {
                      return previousValue + parseInt(currentValue.qty);
                    }
                    else{
                      return 0
                    }
                }, 0);*/

                if(bundle.size_id == element.id)
                {
                  sum = bundle.qty
                }

                assignedQty = assignedQty + parseInt(sum);
              })

              element.assigned =assignedQty
          });

          return sizesWithQtys 
     },
     sizes_correct: function() {
       let sizes_correct = true
         let order = this.order
          let sizesWithQtys =  this.sizes.filter(function(u) {
            if( order[u.database_name] + order[u.database_name + '_GK'] > 0) 
            {
               console.log(u)
              return 1
            }
          })

          sizesWithQtys.forEach(element => {
              element.originalQty = this.order[element.database_name] + this.order[element.database_name + '_GK'];
              let assignedQty = 0

              // Loop through all bundle sizes
              this.order.bundles.forEach(bundle => {
                let sum = 0
               
                if(bundle.size_id == element.id)
                {
                  sum = bundle.qty
                }

                assignedQty = assignedQty + parseInt(sum);
              })

              element.assigned =assignedQty
              
              if(element.originalQty != element.assigned)
              {
                sizes_correct= false
              }
              
          });

          return sizes_correct 

     }
   
  },
  watch: {

   
    
  },
  created() {
     this.getAccessToken()
        .then(() => { 
           this.getSizes();
          this.getOrder();
        });

        
  },
}
</script>